import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Polyglot from './lib/polyglot';

import { AVAILABLE_LANGUAGES } from './config/languages';
import { PAGE_HOME, AVAILABLE_PAGES } from './config/pages';

import dictionary from './i18n';
import App from './App';

const parsePathname = (location) => {
    const fullPathname = location.pathname;
    const basename = process.env.PUBLIC_URL;
    const appPathname = basename ? fullPathname.replace(basename, '') : fullPathname;
    const pathParts = appPathname.split('/').slice(1);

    const language = (AVAILABLE_LANGUAGES.indexOf(pathParts[0]) !== -1) ? pathParts[0] : process.env.DEFAULT_LANGUAGES;
    const page = (AVAILABLE_PAGES.indexOf(pathParts[1]) !== -1) ? pathParts[1] : PAGE_HOME;
    const subpage = pathParts[2] ? pathParts[2] : null;

    const queryString = location.search[0] === '?' ? location.search.substr(1) : location.search;
    const queryPairs = queryString.split('&');
    const query = {};
    queryPairs.forEach((pair) => {
        const pairArray = pair.split('=');
        const key = decodeURIComponent(pairArray[0]);
        const value = decodeURIComponent(pairArray[1] || '');
        if (key || value) {
            query[key] = value;
        }
    });
    const hash = window.location.hash.replace('#', '');

    return {
        language, page, subpage, query, hash
    };
};

class Router extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: process.env.DEFAULT_LANGUAGES,
            page: PAGE_HOME,
            subpage: null,
            query: {},
            routeState: null,
            firstLoad: true,
            hash: null
        };

        this.init = this.init.bind(this);
        this.openPage = this.openPage.bind(this);
        this.updateUrl = this.updateUrl.bind(this);
        this.historyListen = this.historyListen.bind(this);
        this.translate = this.translate.bind(this);

        this.historyUnlisten = null;
        this.polyglot = new Polyglot();
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        this.historyUnlisten();
    }

    init() {
        const { history } = this.props;

        const {
            language, page, subpage, query, hash
        } = parsePathname(history.location);
        this.polyglot.replace(dictionary[language]);
        this.setState({
            language,
            page,
            subpage,
            query,
            hash
        }); // , this.updateUrl);

        this.historyUnlisten = history.listen(this.historyListen);
    }

    historyListen(location, action) {
        if (action === 'POP') {
            setTimeout(() => {
                $('html, body').scrollTop(0);
            }, 400);

            const {
                language, page, subpage, query, hash
            } = parsePathname(location);
            if (language !== this.state.language) {
                this.polyglot.replace(dictionary[language]);
            }
            this.setState({
                language,
                page,
                subpage,
                query,
                hash,
                routeState: null,
                firstLoad: false
            });
        }
    }

    openPage(page, subpage = null, routeState = null, language = null, scroll = true, query = {}, hash) {
        if (scroll && $(window).scrollTop() > 0) {
            if (page === this.state.page) {
                $('body,html').animate({
                    scrollTop: 0
                }, 400);
            } else {
                setTimeout(() => {
                    $('html, body').scrollTop(0);
                }, 400);
            }
        }

        if (language !== null && AVAILABLE_LANGUAGES.indexOf(language) !== -1) {
            if (language !== this.state.language) {
                this.polyglot.replace(dictionary[language]);
            }
            this.setState({
                language,
                page,
                subpage,
                query,
                routeState,
                firstLoad: false,
                hash
            }, this.updateUrl);
        } else {
            this.setState({
                page,
                subpage,
                query,
                routeState,
                firstLoad: false,
                hash
            }, this.updateUrl);
        }
    }

    updateUrl() {
        const { push, replace } = this.props.history;
        const {
            language, page, subpage, query, firstLoad, hash
        } = this.state;

        const slashedPage = page ? `/${ page }` : PAGE_HOME;
        const slashedSubpage = subpage ? `/${ subpage }` : '';
        const hashWithSign = hash ? `#${ hash }` : '';

        let queryString = '';
        if (Object.keys(query).length > 0) {
            Object.keys(query).forEach((key) => {
                const value = query[key] ? `=${ query[key] }` : '';
                if (queryString === '') {
                    queryString = `?${ key }${ value }`;
                } else {
                    queryString = `${ queryString }&${ key }${ value }`;
                }
            });
        }

        if (firstLoad) {
            replace(`${ process.env.PUBLIC_URL }/${ language }${ slashedPage }${ slashedSubpage }${ queryString }${ hashWithSign }`);
        } else {
            push(`${ process.env.PUBLIC_URL }/${ language }${ slashedPage }${ slashedSubpage }${ queryString }${ hashWithSign }`);
        }
    }

    translate(key, options = null) {
        return this.polyglot.t(key, options);
    }

    render() {
        const {
            language, page, subpage, query, firstLoad, routeState, hash
        } = this.state;

        return (
            <App
              language={ language }
              page={ page }
              subpage={ subpage }
              query={ query }
              routeState={ routeState }
              firstLoad={ firstLoad }
              openPage={ this.openPage }
              hash={ hash }
              t={ this.translate }
            />
        );
    }
}

Router.propTypes = {
    history: PropTypes.shape().isRequired
};

export default Router;



// WEBPACK FOOTER //
// ./src/Router.jsx